import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-[#2A1F0A] rounded-lg bg-[#1C1208] overflow-hidden transition-all duration-300" data-id="element-290">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 md:p-6 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-291">
        <span className="font-bold text-lg text-white pr-4" data-id="element-292">{question}</span>
        <ChevronDown className={`w-6 h-6 text-[#D4A843] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-293" />
      </button>

      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`} data-id="element-294">
        <div className="p-4 md:p-6 pt-0 text-[#C8B89A] leading-relaxed" data-id="element-295">
          {answer}
        </div>
      </div>
    </div>;
}